import { render, staticRenderFns } from "./HorizontalTable.vue?vue&type=template&id=885678ce&scoped=true&"
import script from "./HorizontalTable.vue?vue&type=script&lang=js&"
export * from "./HorizontalTable.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalTable.vue?vue&type=style&index=0&id=885678ce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "885678ce",
  null
  
)

export default component.exports